module.exports = __webpack_public_path__ + "static/media/play_store.f29ac739.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/play_store.png
// module id = 292
// module chunks = 0